import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../config/supabase';
import LoadingSpinner from '../components/LoadingSpinner';
import { ArrowLeftIcon } from '../components/icons/NavIcons';
import PageHeader from '../components/PageHeader';

const ProfileEditPage = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!user) return;
      setLoading(true);
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', user.id)
        .single();
      if (!error) {
        // Charge organizer_name avec display_name si vide uniquement au premier chargement
        setProfile({
          ...data,
          organizer_name:
            (data.organizer_name && data.organizer_name !== '')
              ? data.organizer_name
              : (user?.user_metadata?.display_name || '')
        });
      }
      setLoading(false);
    };
    fetchProfile();
  }, [user]);

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase
      .from('profiles')
      .update({
        organizer_name: profile.organizer_name,
        organizer_lastname: profile.organizer_lastname,
        organizer_firstname: profile.organizer_firstname,
        organizer_company_name: profile.organizer_company_name,
        organizer_email: profile.organizer_email,
        organizer_url: profile.organizer_url,
      })
      .eq('id', user.id);
    setLoading(false);
    setSuccess(!error);
  };

  if (loading && !profile) return <LoadingSpinner />;
  if (!profile) return <div>{t('settings.account.loginPrompt')}</div>;

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <PageHeader title={t('settings.account.editProfile')} backPath="/settings" />

      <div className="p-4">
        <form onSubmit={handleSubmit} className="bg-white p-4 rounded-lg shadow-sm space-y-4">
          <div>
            <label className="block mb-1">{t('profile.organizerName')}</label>
            <input
              type="text"
              name="organizer_name"
              value={profile.organizer_name || ''}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1"
            />
          </div>
          <div>
            <label className="block mb-1">{t('profile.organizerLastname')}</label>
            <input
              type="text"
              name="organizer_lastname"
              value={profile.organizer_lastname || ''}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1"
            />
          </div>
          <div>
            <label className="block mb-1">{t('profile.organizerFirstname')}</label>
            <input
              type="text"
              name="organizer_firstname"
              value={profile.organizer_firstname || ''}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1"
            />
          </div>
          <div>
            <label className="block mb-1">{t('profile.organizerCompanyName')}</label>
            <input
              type="text"
              name="organizer_company_name"
              value={profile.organizer_company_name || ''}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1"
            />
          </div>
          <div>
            <label className="block mb-1">{t('profile.organizerEmail')}</label>
            <input
              type="email"
              name="organizer_email"
              value={profile.organizer_email || ''}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1"
              placeholder="contact@example.com"
            />
          </div>
          <div>
            <label className="block mb-1">{t('profile.organizerUrl')}</label>
            <input
              type="text"
              name="organizer_url"
              value={profile.organizer_url || ''}
              onChange={handleChange}
              className="w-full border rounded px-2 py-1"
            />
          </div>
          <button
            type="submit"
            className="bg-bleu1 text-white py-2 px-6 rounded hover:bg-bleu3 transition-all duration-200 hover:shadow-md hover:scale-105"
            disabled={loading}
          >
            {loading ? t('common.loading') : t('common.save')}
          </button>
          {success && <p className="text-green-600">{t('common.saved')}</p>}
        </form>
      </div>
    </div>
  );
};

export default ProfileEditPage;

